import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEventListener } from '@beef/react';
import { useEffect, useRef, useState } from 'react';
import { getSpaceVariable } from "../../../../utils/variables";
var DEFAULT_OFFSET = 20;
var DEFAULT_RADIUS = 32;
export var useSheetScroll = function useSheetScroll() {
  var _useState = useState(DEFAULT_OFFSET),
    _useState2 = _slicedToArray(_useState, 2),
    topOffset = _useState2[0],
    setTopOffset = _useState2[1];
  var _useState3 = useState(DEFAULT_RADIUS),
    _useState4 = _slicedToArray(_useState3, 2),
    radius = _useState4[0],
    setRadius = _useState4[1];
  var scrollRef = useRef(null);
  var defaultRadiusRef = useRef(0);
  var defaultOffsetRef = useRef(0);
  useEffect(function () {
    defaultOffsetRef.current = getSpaceVariable(scrollRef, '500') || DEFAULT_OFFSET;
    defaultRadiusRef.current = getSpaceVariable(scrollRef, '800') || DEFAULT_RADIUS;
  }, []);
  var scrollAnalyze = function scrollAnalyze() {
    if (scrollRef.current) {
      var defOffset = defaultOffsetRef.current;
      var defRadius = defaultRadiusRef.current;
      var offset = Math.max(0, defOffset - scrollRef.current.scrollTop / 2);
      setTopOffset(offset);
      setRadius(defRadius - (defOffset - offset) * defRadius / defOffset);
    }
  };
  useEventListener('scroll', scrollAnalyze, scrollRef);
  return {
    scrollRef: scrollRef,
    topOffset: topOffset,
    radius: radius
  };
};